import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import HeroSection from '@/components/HeroSection';
import SectionHeading from '@/components/SectionHeading';
import Gallery from '@/components/Gallery';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const AbkStonePulti = () => {
  const galleryImages = [
    { 
      src: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?q=80&w=2070', 
      alt: 'ABK stone pulti v kuhinji' 
    },
    { 
      src: 'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?q=80&w=2070', 
      alt: 'ABK stone pulti detajl' 
    },
    { 
      src: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?q=80&w=2070', 
      alt: 'ABK stone pulti v moderni kuhinji' 
    },
  ];

  const specs = [
    { name: 'Material', value: 'ABK stone' },
    { name: 'Odpornost', value: 'Visoka proti praskam, madežem in vročini' },
    { name: 'Vzdrževanje', value: 'Enostavno čiščenje' },
    { name: 'Barve', value: 'Široka paleta' },
    { name: 'Uporaba', value: 'Kuhinje, kopalnice, poslovni prostori' },
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-16">
        <HeroSection 
          title="ABK stone pulti"
          subtitle="Inovativni pulti za moderne kuhinje in kopalnice"
          imageSrc="https://images.unsplash.com/photo-1600607688969-a5bfcd646154?q=80&w=2070"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />

        <section className="py-16 bg-stone-50">
          <div className="container-custom">
            <SectionHeading 
              title="ABK stone pulti"
              subtitle="Inovativni ABK stone pulti za vaš dom"
            />
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-12">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="prose max-w-none">
                  <p className="text-lg text-stone-700 mb-4">
                    ABK stone pulti so inovativna rešitev za moderne kuhinje in kopalnice. Izdelani so iz visokokakovostnega materiala, ki združuje estetiko, trajnost in funkcionalnost.
                  </p>
                  <p className="text-lg text-stone-700 mb-4">
                    Na voljo so v različnih barvah in vzorcih, kar omogoča prilagoditev vsakemu slogu interierja. Njihova enostavna montaža in vzdrževanje jih naredita še bolj priljubljene.
                  </p>
                  <p className="text-lg text-stone-700 mb-8">
                    ABK stone pulti so odporen proti praskam, madežem in visokim temperaturam, kar jih naredi idealne za uporabo v kuhinjah in kopalnicah, kjer so izpostavljeni različnim vplivom.
                  </p>
                  
                  <h3 className="text-xl font-semibold text-stone-800 mb-4">Tehnične specifikacije</h3>
                  <ul className="space-y-2">
                    {specs.map((spec, index) => (
                      <li key={index} className="flex justify-between items-center border-b border-stone-200 py-2">
                        <span className="font-medium text-stone-800">{spec.name}:</span>
                        <span className="text-stone-600">{spec.value}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="mt-8">
                  <Button size="lg" className="bg-secondary hover:bg-secondary/90" asChild>
                    <a href="/kontakt" className="flex items-center gap-2">
                      Zahtevaj ponudbo <ArrowRight size={16} />
                    </a>
                  </Button>
                </div>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <Gallery images={galleryImages} />
              </motion.div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AbkStonePulti;